<sag-ui-button [color]="type" (click)="clicked($event)" size="sm">{{ translate ? (text | translate) : text }}</sag-ui-button>
